import React, { useEffect } from 'react';
import { track } from '@amplitude/analytics-browser';
import { Alert } from '@nimbus-ds/components';
import { useTranslationWithPrefix } from 'commons/utils';
import { config } from 'config';
import moment from 'moment';
import { PendingTrialPeriodAlertPage } from '../PendingTrialPeriodAlert';

interface InterfacePendingReviewAlert {
  updatedAt: string;
  blockedTrialPeriod?: boolean;
  page: PendingTrialPeriodAlertPage;
}

const PendingReviewAlert = ({
  updatedAt,
  blockedTrialPeriod,
  page,
}: InterfacePendingReviewAlert): JSX.Element => {
  const { t } = useTranslationWithPrefix(
    'configuration.personalData.kycV2.pending_review',
  );

  useEffect(() => {
    track('pago-nube-documentacion-analisis-view', {
      page,
      isBlockedTrialPeriod: blockedTrialPeriod,
    });
  }, [page, blockedTrialPeriod]);

  const description = t('description', {
    interpolation: { escapeValue: false },
    updatedDate: moment(updatedAt).format('DD/MM'),
    kycAnalysisDays: config.kyc.analysisDays,
  });

  const pausedSuffix = blockedTrialPeriod ? ` ${t('pausedSuffix')}` : '';

  return (
    <Alert
      appearance="neutral"
      title={t('title')}
      data-testid="pending-review-alert"
    >
      {description}
      {pausedSuffix}
    </Alert>
  );
};

export default PendingReviewAlert;
